import { dexterURL, baseUrl } from 'shared/campaign_url'
import CountryBlockedError from 'components/common/country_blocked'
import CampaignEligibility from 'components/common/campaign_eligibility'
import { ELIGIBILITY_STATUS, POOLS_CAMPAIGN_TYPES } from 'shared/shared_consts'

const { CROWD_FUNDING } = POOLS_CAMPAIGN_TYPES

export function createCampaignEligibilityCheck(
  state,
  nextState,
  campaignType,
  CreatePage,
  callback
) {
  const cipStatus =
    state.current_user.CIPEligibility &&
    state.current_user.CIPEligibility[campaignType]
  if (state.current_user.moneypools_blocked) {
    return callback(null, CountryBlockedError)
  } else if (
    campaignType === CROWD_FUNDING &&
    !state.current_user.crowdfunding_enabled
  ) {
    //when elmo is not enabled for GN pools based on country
    window.location.href = baseUrl(location.hostname, '')
    return
  } else if (
    cipStatus &&
    cipStatus.CIPStatus === ELIGIBILITY_STATUS.INELIGIBLE
  ) {
    if (cipStatus.CIPStatusCode === 'NEED_MORE_DATA') {
      const returnUrl = nextState.location.pathname
      location.href = dexterURL(returnUrl)
      return
    }
    return callback(null, CampaignEligibility)
  }
  return callback(null, CreatePage)
}
